import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';
import { Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Seperator from '@dex/bubl-dash/src/lib/components/Seperator/Seperator';
import { Line } from '@dex/bubl-dash';
import AvatarsPreview from './AvatarsPreview';

const AvatarsSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Avatars Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: 'User',
                                key: 'user',
                                format: "ModelLink"
                            }
                        ]}
                        columnB={[
                            {
                                label: 'Gender',
                                key: 'gender',
                                format: 'titleCase'
                            }
                        ]}
                        columnC={[
                            {
                                label: 'Sport',
                                key: 'sport',
                                format: 'titleCase'
                            }
                        ]}
                    />

                    <Space height={8} />

                    <Line />

                    <AvatarsPreview
                        config={data.config}
                        bodyType={data.bodyType}
                    />


                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default AvatarsSingleView;
